import { global } from '@/global';
import store from "@/store";

export function hasBankType() {

	let type = store.getters.getBankType;
	let _type = sessionStorage.getItem(global['BANK_TYPE']) || null;

	return type === 'individual' && _type == 'individual';
}

export async function checkBankType(to, from, next) {
	next()
	// if (hasBankType()) {
	// 	next();
	// } else {
	// 	store
	// 		.dispatch("logout")
	// 		.then(() => next({ name: "individualLogin" }));
	// }
}

